<mat-menu #ownerMenu="matMenu" class="owner-popover-menu" xPosition="before">
  <ng-template matMenuContent>
    <!-- stopPropagation so menu interactions / typing don't bubble to the row or close the menu -->
    <div class="owner-popover" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <div class="current-owner" *ngIf="order.owner as o">
        <span class="co-label">{{ 'quotations_and_orders.ownership.owner' | translate }}</span>
        <span class="co-user">
          <span class="co-avatar" [style.background]="getUserColor(o)">{{ userInitials(o.name) }}</span>
          <span class="co-name">{{ o.name }}</span>
        </span>
      </div>

      <div class="search-box">
        <div class="search-field">
          <input
            #searchInput
            type="text"
            cdkFocusInitial
            [formControl]="searchControl"
            (input)="onSearchInput(searchControl.value)"
            (keydown.tab)="$event.preventDefault(); focusOption(0)"
            (keydown.arrowDown)="$event.preventDefault(); focusOption(0)"
            (keydown.enter)="$event.preventDefault(); selectFirstOption()"
            [placeholder]="'quotations_and_orders.ownership.select_user' | translate"
            autocomplete="off"
          />
          <mat-spinner *ngIf="loadingOptions" diameter="16" class="search-spinner"></mat-spinner>
          <div class="search-icon" *ngIf="!loadingOptions">
            <img src="assets/icones/search_icon.svg" alt="" />
          </div>
        </div>
      </div>

      <ul class="user-list">
        <li *ngFor="let u of options; let i = index">
          <button
            #optionBtn
            type="button"
            class="user-item"
            [class.is-current]="u.id === order.owner?.id"
            [disabled]="savingId != null"
            (click)="selectUser(u)"
            (keydown.arrowDown)="$event.preventDefault(); focusOption(i + 1)"
            (keydown.arrowUp)="$event.preventDefault(); focusOption(i - 1)"
          >
            <span class="ui-avatar">
              <img
                *ngIf="u.image; else initialsAvatar"
                [src]="'data:image/jpeg;base64,' + u.image"
                [alt]="u.name"
                width="28"
                height="28"
              />
              <ng-template #initialsAvatar>
                <span class="ui-initials" [style.background]="getUserColor(u)">{{ userInitials(u.name) }}</span>
              </ng-template>
            </span>
            <span class="ui-text">
              <span class="ui-name">{{ u.name }}</span>
              <span class="ui-email" *ngIf="u.email">{{ u.email }}</span>
            </span>
            <mat-spinner *ngIf="savingId === u.id" diameter="16" class="ui-spinner"></mat-spinner>
            <svg *ngIf="savingId == null && u.id === order.owner?.id" class="ui-check" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 6L9 17L4 12" stroke="#6449DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </li>
        <li *ngIf="!loadingOptions && options.length === 0" class="user-empty">
          {{ 'quotations_and_orders.ownership.no_results' | translate }}
        </li>
      </ul>
    </div>
  </ng-template>
</mat-menu>
